import React from 'react';

import LegalPage from '../components/LegalPage';
import { TERMS_HTML, TERMS_TOC } from '../legal/termsContent';

const Terms: React.FC = () => (
  <LegalPage title="Terms & Conditions" html={TERMS_HTML} toc={TERMS_TOC} />
);

export default Terms;
